$(document).ready(function ()
{
	// ----------------------------------------------------------------
	// Build codemirror inputs and register them into a scopped var
	// ----------------------------------------------------------------

	var codemirror_editors = [];

	$('.codemirror_html').each(function(){
		if($(this).val().length==0)
		{
			$(this).val($(this).attr('placeholder'));
		}
		var editor = CodeMirror.fromTextArea(this, {
			mode: "htmlmixed",
			value: this.value,
			lineNumbers: true,
			fullscreen:true,
			autoCloseBrackets: true,
			matchBrackets: true,
			showCursorWhenSelecting: true,
			theme: "monokai",
			tabSize: 4,
			indentUnit:4,
			indentWithTabs:true,
			foldGutter: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
			extraKeys: {
				"Ctrl-Space": "autocomplete",
				"Ctrl-F": "findPersistent",
				"Ctrl-Q": function(cm){
					cm.foldCode(cm.getCursor());
				},
				"F11": function(cm) {
					cm.setOption("fullScreen", !cm.getOption("fullScreen"));
				},
				"Esc": function(cm) {
					if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
				}
			},
		});
		editor.on("change", function(editor, change) {
			editor.save();
		});
		codemirror_editors.push(editor);
	});

	$('.codemirror_scss').each(function(){
		if($(this).val().length==0)
		{
			$(this).val($(this).attr('placeholder'));
		}
		var editor = CodeMirror.fromTextArea(this, {
			mode: "text/x-scss",
			value: this.value,
			lineNumbers: true,
			fullscreen:true,
			autoCloseBrackets: true,
			matchBrackets: true,
			showCursorWhenSelecting: true,
			theme: "monokai",
			tabSize: 4,
			indentUnit:4,
			indentWithTabs:true,
			foldGutter: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
			extraKeys: {
				"Ctrl-Space": "autocomplete",
				"Ctrl-F": "findPersistent",
				"Ctrl-Q": function(cm){
					cm.foldCode(cm.getCursor());
				},
				"F11": function(cm) {
					cm.setOption("fullScreen", !cm.getOption("fullScreen"));
				},
				"Esc": function(cm) {
					if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
				}
			},
		});
		editor.on("change", function(editor, change) {
			editor.save();
		});
		codemirror_editors.push(editor);
	});

	$('.codemirror_css').each(function(){
		if($(this).val().length==0)
		{
			$(this).val($(this).attr('placeholder'));
		}
		var editor = CodeMirror.fromTextArea(this, {
			mode: "text/css",
			value: this.value,
			lineNumbers: true,
			fullscreen:true,
			autoCloseBrackets: true,
			matchBrackets: true,
			showCursorWhenSelecting: true,
			theme: "monokai",
			tabSize: 4,
			indentUnit:4,
			indentWithTabs:true,
			foldGutter: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
			extraKeys: {
				"Ctrl-Space": "autocomplete",
				"Ctrl-F": "findPersistent",
				"Ctrl-Q": function(cm){
					cm.foldCode(cm.getCursor());
				},
				"F11": function(cm) {
					cm.setOption("fullScreen", !cm.getOption("fullScreen"));
				},
				"Esc": function(cm) {
					if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
				}
			},
		});
		editor.on("change", function(editor, change) {
			editor.save();
		});
		codemirror_editors.push(editor);
	});

	$('.codemirror_js').each(function(){
		var editor = CodeMirror.fromTextArea(this, {
			mode: "text/javascript",
			value: this.value,
			lineNumbers: true,
			fullscreen:true,
			autoCloseBrackets: true,
			matchBrackets: true,
			showCursorWhenSelecting: true,
			theme: "monokai",
			tabSize: 4,
			indentUnit:4,
			indentWithTabs:true,
			foldGutter: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
			extraKeys: {
				"Ctrl-Space": "autocomplete",
				"Ctrl-F": "findPersistent",
				"Ctrl-Q": function(cm){
					cm.foldCode(cm.getCursor());
				},
				"F11": function(cm) {
					cm.setOption("fullScreen", !cm.getOption("fullScreen"));
				},
				"Esc": function(cm) {
					if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
				}
			},
		});
		editor.on("change", function(editor, change) {
			editor.save();
		});
		codemirror_editors.push(editor);
	});

	// ----------------------------------------------------------------
	// Refresh codemirror inputs after a small delay - to prevent bad size computation
	// ----------------------------------------------------------------

	setTimeout(function() {
		for(var i=0; i<codemirror_editors.length; i++)
			codemirror_editors[i].refresh();
	}, 100);

	// ----------------------------------------------------------------
	// Handle codemirror inputs refresh on admin tabs toggling
	// ----------------------------------------------------------------

	if($('.nav-tabs').length>0)
	{
		$('.nav-tabs a').on('click',function(e){
			if(codemirror_editors && codemirror_editors.length)
			{
				setTimeout(function() {
					for(var i=0; i<codemirror_editors.length; i++)
						codemirror_editors[i].refresh();
				}, 100);
			}

		});
	}
});